import React from 'react';
import './linea.css';

class Linea extends React.Component {

    render(){
        var date  = new Date(this.props.paso.fechaModificacion);
        const dateTimeFormat = new Intl.DateTimeFormat('ex-MX', { year: 'numeric', month: '2-digit', day: '2-digit' }) 
        const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat.formatToParts(date); 
        let clase = this.props.paso.orden<this.props.pasoActual.orden?"pasado":(this.props.paso.orden===this.props.pasoActual.orden?"actual"+(this.props.paso.resultado==="Perdida"?" error":""):"futuro");
        return  <div className="pt-2 pb-2">
                    <span className={clase+" texto"}>{this.props.paso.fechaModificacion?`${month}/${day}/${year}`:'--/--/----'}</span> <span className={clase}>|</span> <span className={clase+ " texto"}>{this.props.paso.nombreEstatus===null?this.props.paso.actividad:this.props.paso.nombreEstatus}</span>
                </div>
    }
}

export default Linea;